import updateQueryParams from '@helpers/updateQueryParams';

/**
 * THIS IS FOR THE TEMPORARY POC UNTIL REPLACED BY BE
 */
export const generateStyleFlexUrl = (styleFlex, url, dimension = null, dpr = null) => {
    if (url.indexOf(styleFlex.url) !== -1) {
        return url;
    }

    const {
        highRezSize,
        params,
        bucket
    } = styleFlex;

    let size = dimension;

    if (!size) {
        const activeUrl = new URL(updateQueryParams(url));
        size = activeUrl.searchParams.get('size');
    }

    const current = new URL(updateQueryParams(url, { size }));
    const parts = current.pathname.split('/');
    const sourceImage = `${bucket}${parts[1]}/${parts[2]}`;
    const customParams = {
        w: size.replace('w', '')
    };

    if (dpr) {
        customParams.dpr = dpr;
    }

    if (customParams.w === 'source' || customParams.w === 'source_wide') {
        customParams.w = highRezSize;
    }

    return updateQueryParams(`${styleFlex.url}/${sourceImage}`, {
        ...params,
        ...customParams
    });
};
